// extracted by mini-css-extract-plugin
export var actions = "_mm-d";
export var benefitCard = "_mm-a";
export var benefitIcon = "_mm-b";
export var benefitLabel = "_mm-c";
export var benefits = "_mm-9";
export var bodyText = "_mm-8";
export var closeButton = "_mm-2";
export var content = "_mm-3";
export var eyebrow = "_mm-4";
export var heading = "_mm-5";
export var image = "_mm-f";
export var imagePanel = "_mm-e";
export var modal = "_mm-0";
export var shell = "_mm-1";
export var title = "_mm-6";
export var titleOffer = "_mm-7";